<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Marks Entry Status </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd" />
        </v-col>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sem" item-value="id" :items="sem_list"
            item-text="display_name" label="Semester" outlined />
        </v-col>
        <v-col sm="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
            :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
            item-text="div_name" label="Division" outlined />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-btn class="mt-6 button" :loading="loader" @click="getCourses">Proceed</v-btn>
        </v-col>
      </v-row>
      <v-row dense v-if="crs_list != null">
        <v-col cols="12" sm="12" md="12">
          <!-- <v-col sm="2">
                    <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export To Excel</v-btn>
                </v-col> -->
          <div id="my-table-id">
            <v-simple-table class="elevation-1 mytable" dense>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Academic Year</th>
                  <th>Standard</th>
                  <th>Division</th>
                  <th>Course</th>
                  <th>Teacher</th>
                  <th>Course Type</th>
                  <th>Mark Entry Type</th>
                  <th>Assessment Scheme</th>
                  <th>Grading Scheme</th>
                  <th>Student</th>
                  <th class="" v-for="header in component_headers" :key="header">
                    <center>{{ header }}</center>
                  </th>
                </tr>
                <tr>
                  <!-- <th class="toolbar"></th>
                                <th class="toolbar"></th>
                                <th class="toolbar"></th>
                                <th class="toolbar"></th>
                                <th class="toolbar"></th>
                                <th class="toolbar"></th>
                                <th class="toolbar"></th>
                                <th class="toolbar"></th>
                                <th class="toolbar"></th>
                                <th class="toolbar"></th> -->
                  <th class="toolbar" colspan="11"></th>
                  <th class="toolbar" v-for="header in component_headers" :key="header">
                    Check / Balance
                  </th>
                </tr>
              </thead>
              <tbody style="overflow-y: scroll">
                <tr v-for="crs in crs_list" :key="crs.crs_id">
                  <td>{{ crs.srno }}</td>
                  <td>{{ crs.ay }}</td>
                  <td>{{ crs.std }}</td>
                  <td>{{ crs.div }}</td>
                  <td>{{ crs.crs_name }}</td>
                  <td>{{ crs.inst_name }}</td>
                  <td>{{ crs.coursetype }}</td>
                  <td>{{ crs.entry_type }}</td>
                  <td>{{ crs.courseassessmentscheme }}</td>
                  <td>{{ crs.gradingscheme }}</td>
                  <td>
                    <v-btn class="btn-css btn" @click="get_learners(crs.crs_off_learner)">{{ crs.crs_off_learner.length
                      }}</v-btn>
                  </td>
                  <td v-for="header in crs.marks_status" :key="header">
                    <center>
                      {{ header.total_check }}/<span v-if="header.balance > 0" class="text-color">{{ header.balance
                        }}</span>
                      <span v-else>{{ header.balance }}</span>
                    </center>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="1200px">
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Course Learners </strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-col cols="12" sm="12" md="12">
          <v-card class="box" v-if="learners != ''">
            <v-row class="p-0 m-0" v-if="learners.length > 0">
              <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
              <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table"
                  single-line hide-details></v-text-field>
              </v-col>
            </v-row>
            <v-data-table v-if="learners.length > 0" dense :headers="headers" :items="learners" :search="search"
              class="elevation-1 mytable">
            </v-data-table>
          </v-card>
        </v-col>
        <v-row justify="center">
          <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      search: "",
      snackbar_msg: "",
      color: "",
      // extraBreadcrumbItems: [
      

      // ],
      // breadcrumbClass: "breadcrumb-style1",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      show_tt: false,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      loader: false,
      sem: null,
      crs_list: null,
      learners: [],
      dialog: false,
      crs_off_learner: [],
      ass_scheme_deatils_list: [],
      gscheme_list: [],
      ass_type_list: [],
      g_type_list: [],
      component_headers: [],
      sem_list: [],
      role:null,
      headers: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },
        {
          text: "Academic Year",
          align: "center",
          sortable: false,
          value: "academicyear",
        },
        {
          text: "Standard",
          align: "center",
          sortable: false,
          value: "std",
        },
        {
          text: "Division",
          align: "center",
          sortable: false,
          value: "div",
        },
        {
          text: "PRN No",
          align: "center",
          sortable: false,
          value: "registration_number",
        },
        {
          text: "Roll No",
          align: "center",
          sortable: false,
          value: "rollno",
        },
        {
          text: "Name",
          align: "center",
          sortable: false,
          value: "name",
        },
      ],
    };
  },
  methods: {
    ExportToExcel() {
      var htmltable = document.getElementById("my-table-id");
      var html = htmltable.outerHTML;
      window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    getCourses() {
      let div = this.div.div_off_id;
      if (this.div.div_off_id) {
        div = this.div.div_off_id;
      } else {
        div = this.div;
      }
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        division: div,
        sem: this.sem,
        role: this.role
      };
      this.loader = true;
      axios
        .post("/Examination/marksEntrystatus", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.crs_list = res.data.crs_list;
            this.component_headers = res.data.component_headers;
            this.loader = false;
          }
        })
        .catch((error) => {
          this.loader = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          "use strict";
          this.loader = false;
        });
    },
    get_learners(crs_off_learner) {
      const data = {
        crs_off_learner: crs_off_learner,
      };
      axios
        .post("/Examination/get_learners_data", data)
        .then((res) => {
          this.learners = res.data.learners;
          this.dialog = true;
        })
        .catch((error) => {
          this.overlay = true;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          "use strict";
          this.overlay = false;
        });
    },
    onload() {
      this.role = sessionStorage.getItem("para_role"); //localStorage.getItem("para_role");
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sem_list = res.data.sem_list;
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          //stop loader
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.text-color {
  font-weight: bold;
  color: red;
  font-size: small;
}

.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
</style>